import { Injectable } from '@angular/core';
import { Capacitor } from '@capacitor/core';
import { Preferences } from '@capacitor/preferences';
import { from, Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})
export class StorageService {
    private readonly isNative = Capacitor.isNativePlatform();

    setItem(key: string, value: any): Observable<void> {
        const stringValue = JSON.stringify(value);
        if (this.isNative) {
            return from(Preferences.set({ key, value: stringValue }));
        } else {
            localStorage.setItem(key, stringValue);
            return of(void 0);
        }
    }

    getItem<T>(key: string): Observable<T | null> {
        if (this.isNative) {
            return from(Preferences.get({ key })).pipe(
                map(({ value }) => {
                    if (!value) return null;
                    try {
                        return JSON.parse(value) as T;
                    } catch (error) {
                        console.warn(`Failed to parse stored value for key "${key}":`, error);
                        return value as unknown as T;
                    }
                })
            );
        } else {
            const storedValue = localStorage.getItem(key);
            if (!storedValue) return of(null);
            try {
                return of(JSON.parse(storedValue) as T);
            } catch (error) {
                console.warn(`Failed to parse stored value for key "${key}":`, error);
                return of(storedValue as unknown as T);
            }
        }
    }

    removeItem(key: string): Observable<void> {
        if (this.isNative) {
            return from(Preferences.remove({ key }));
        } else {
            localStorage.removeItem(key);
            return of(void 0);
        }
    }
}
